import React, { Component } from 'react';
import '../styles/video-player-control.css';
import Asset from '../../../requests/apa/Asset';
import { Column, cls } from '../../../packages/components';

import {
    CONTROL_RECORDING,
    CONTROL_BACKWARD,
    CONTROL_FORWARD,
    CONTROL_SPEED_BACKWARD,
    CONTROL_SPEED_FORWARD,
    CONTROL_TS_FORWARD,
    CONTROL_TS_BACKWARD,
    CONTROL_PLAY,
    CONTROL_PAUSE,
    CONTROL_EPG,
    CONTROL_LANGUAGE,
    CONTROL_EXIT,
    CONTROL_SERIE,
    CONTROL_FAVORITE,
    CONTROL_UNFAVORITE
} from './constants';
import Utils from '../../../utils/Utils';
import {applyOutLineFocus} from "../../../components/Focus/utils";
import logger from 'src/utils/logger/logger';

class VideoPlayerControl extends Component {

    constructor(props) {
        super(props);
        this.isPs4 = false;
        this.bPs4 = '';
        this.focusable = props.control.enabled ? 'whenfocusable' : '';
        this.disabled = 'video-player-control-button-disabled';
        this.typeContent = props.typeContent

        const extraClassName =  props.control.extraClassName ?  props.control.extraClassName : '';
        this.iconClass = `video-player-control-button ${this.focusable} action ${this.bPs4} pcfocus-transition ${extraClassName}`; //
    }

    controlOnclic(e) {
        if (!this.props.control.enabled) return;
        this.props.onClic && this.props.onClic(e);
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    shouldComponentUpdate(newProps, newState) {
        const difControlType = this.props.control.type !== newProps.control.type;
        const difControlEnabled = this.props.control.enabled !== newProps.control.enabled;
        const difControlText = this.props.control.title !== newProps.control.title;

        // Focus nav button is changing? re-render component, dirty but fast
        // plain object, four attrs... update navigation.
        // When? when player controls changed...for example VOD, when we set
        // the state because its a serie (then add change episodes controls next setState)
        const difFocusNavigation = JSON.stringify(this.props.nav) !== JSON.stringify(newProps.nav);

        return difControlType || difControlEnabled || difFocusNavigation || difControlText;
    }

    handleMouseEnter = (e) => {
        Utils.handleMouseEnter(e)
    }

    resolveIcon(control, id, nav) {
        let button;
      const classOutLineFocus = applyOutLineFocus();

      switch (control.type) {

            case CONTROL_PLAY:
                button = <div className="video-player-control-cell">
                    <div className="video-player-control-button-icon">
                        <a
                            id={id}
                            href="javascript:void(0)"
                            key={control.type}
                            className={`${this.iconClass} video-player-control-main-button-play video-player-control-main-button ${classOutLineFocus}`}
                            onClick={(e) => this.controlOnclic(e)}
                            ref={`ahref_${control.type}`}
                            data-sn-left={nav.left}
                            data-sn-right={nav.right}
                            data-sn-up={nav.up}
                            data-sn-down={nav.down}
                            onMouseEnter={(e) => this.handleMouseEnter(e)}
                        >
                            <span className="ihelper"></span>
                            <img
                                src={Asset.get('playing_playerControls_toolbar_button_play')}
                                alt="player_controls_play_icon"
                            />
                        </a>
                    </div>
                    <div className="video-player-control-button-title" id={`video_control_title`}>
                        {control.title}
                    </div>
                </div>
                break;
            case CONTROL_PAUSE:
                button = <div className="video-player-control-cell">
                    <div className="video-player-control-button-icon">
                        <a
                            id={id}
                            href="javascript:void(0)"
                            key={control.type}
                            className={`${this.iconClass} video-player-control-main-button-pause video-player-control-main-button ${classOutLineFocus}`}
                            onClick={(e) => this.controlOnclic(e)}
                            ref={`ahref_${control.type}`}
                            data-sn-left={nav.left}
                            data-sn-right={nav.right}
                            data-sn-up={nav.up}
                            data-sn-down={nav.down}
                            onMouseEnter={(e) => this.handleMouseEnter(e)}
                        >
                             <span className="ihelper"></span>
                            <img
                                src={Asset.get('playing_playerControls_toolbar_button_pause')}
                                alt="player_controls_pause_icon"
                            />
                        </a>
                    </div>
                    <div className="video-player-control-button-title" id={`video_control_title`}>
                        {control.title}
                    </div>
                </div>;
                break;

            case CONTROL_RECORDING:
                let hasClick = true;
                if (control.enabled) {
                    this.focusable = 'whenfocusable';
                    this.disabled = '';
                    this.iconClass = `video-player-control-button ${this.focusable} action ${this.bPs4}`;
                }
                else {
                    this.focusable = '';
                    this.disabled = 'video-player-control-button-disabled';
                    this.iconClass = `video-player-control-button ${this.focusable} action ${this.bPs4}`;
                    hasClick = false;
                    this.iconClass = `video-player-control-button action ${this.bPs4}`;
                }

                button = <div className="video-player-control-cell">
                    <div className="video-player-control-button-icon">
                        <a
                            id={id}
                            href="javascript:void(0)"
                            key="record"
                            className={`${this.iconClass} video-player-control-button-recording ${classOutLineFocus}`}
                            onClick={(e) => this.controlOnclic(e)}
                            ref={`ahref_${control.type}`}
                            data-sn-left={nav.left}
                            data-sn-right={nav.right}
                            data-sn-up={nav.up}
                            data-sn-down={nav.down}
                            onMouseEnter={(e) => this.handleMouseEnter(e)}
                        >
                            <span className="ihelper"></span>
                            <img
                                src={Asset.get('playing_playerControls_toolbar_button_canRecord', Asset.get('player_controls_record_icon'))}
                                alt="player_controls_record_icon"
                            />
                        </a>
                    </div>
                    <div className="video-player-control-button-title">
                        {control.title}
                    </div>
                </div>
                break;
            case CONTROL_BACKWARD:
                button = <div className="video-player-control-cell">
                    <div className="video-player-control-button-icon">
                        <a
                            id={id}
                            href="javascript:void(0)"
                            key="backward"
                            className={`${this.iconClass} video-player-control-button-backward ${classOutLineFocus}`}
                            onClick={(e) => this.controlOnclic(e)}
                            ref={`ahref_${control.type}`}
                            data-sn-left={nav.left}
                            data-sn-right={nav.right}
                            data-sn-up={nav.up}
                            data-sn-down={nav.down}
                            onMouseEnter={(e) => this.handleMouseEnter(e)}
                        >
                            <span className="ihelper"></span>
                            <img
                                src={Asset.get('playing_playerControls_toolbar_button_rewind', Asset.get('player_controls_backward_icon'))}
                                alt="player_controls_step_backward_icon"
                            />
                        </a>
                    </div>
                    <div
                        className="video-player-control-button-title"
                        ref={`video_control_title_${control.type}`}
                        data={`video_control_title_${control.type}`}
                    >
                        {control.title}
                    </div>
                </div>
                break;
                case CONTROL_TS_BACKWARD:
                button = <div className="video-player-control-cell">
                    <div className="video-player-control-button-icon">
                        <a
                            id={id}
                            href="javascript:void(0)"
                            key="backward"
                            className={`${this.iconClass} video-player-control-button-backward ${classOutLineFocus}`}
                            onClick={(e) => this.controlOnclic(e)}
                            ref={`ahref_${control.type}`}
                            data-sn-left={nav.left}
                            data-sn-right={nav.right}
                            data-sn-up={nav.up}
                            data-sn-down={nav.down}
                            onMouseEnter={(e) => this.handleMouseEnter(e)}
                        >
                            <span className="ihelper"></span>
                            <img
                                src={Asset.get('playing_playerControls_toolbar_button_seekTsRewind', Asset.get('player_controls_backward_icon'))}
                                alt="player_controls_step_backward_icon"
                            />
                        </a>
                    </div>
                    <div
                        className="video-player-control-button-title"
                        ref={`video_control_title_${control.type}`}
                        data={`video_control_title_${control.type}`}
                    >
                        {control.title}
                    </div>
                </div>
                break;
                case CONTROL_SPEED_BACKWARD:
                    button = <div className="video-player-control-cell">
                        <div className="video-player-control-button-icon">
                            <a
                                id={id}
                                href="javascript:void(0)"
                                key="backward"
                                className={`${this.iconClass} video-player-control-button-backward ${classOutLineFocus}`}
                                onClick={(e) => this.controlOnclic(e)}
                                ref={`ahref_${control.type}`}
                                data-sn-left={nav.left}
                                data-sn-right={nav.right}
                                data-sn-up={nav.up}
                                data-sn-down={nav.down}
                                onMouseEnter={(e) => this.handleMouseEnter(e)}
                            >
                                <span className="ihelper"></span>
                                <img
                                    src={Asset.get('playing_playerControls_toolbar_button_rewind', Asset.get('player_controls_backward_icon'))}
                                    alt="player_controls_step_backward_icon"
                                />
                            </a>
                        </div>
                        <div
                            className="video-player-control-button-title"
                            ref={`video_control_title_${control.type}`}
                            data={`video_control_title_${control.type}`}
                        >
                            {control.title}
                        </div>
                    </div>
                    break;
            case CONTROL_EPG:
                button = <div className="video-player-control-cell">

                    <div className="video-player-control-button-icon">
                        <a
                            id={id}
                            href="javascript:void(0)"
                            key="record"
                            className={`${this.iconClass} ${classOutLineFocus}`}
                            onClick={(e) => this.controlOnclic(e)}
                            ref={`ahref_${control.type}`}
                            data-sn-left={nav.left}
                            data-sn-right={nav.right}
                            data-sn-up={nav.up}
                            data-sn-down={nav.down}
                            onMouseEnter={(e) => this.handleMouseEnter(e)}
                        >
                            <span className="ihelper"></span>
                            <img
                                src={Asset.get('playing_playerControls_toolbar_button_guide', Asset.get('player_controls_epg_icon'))}
                                alt="player_controls_epg_icon"
                            />
                        </a>
                    </div>
                    <div
                        className="video-player-control-button-title"
                        ref={`video_control_title_${control.type}`}
                    >
                        {control.title}
                    </div>
                </div>
                    ;
                break;

            case CONTROL_LANGUAGE:
                button = <div className="video-player-control-cell">

                    <div className="video-player-control-button-icon">
                        <a
                            id={id}
                            href="javascript:void(0)"
                            key="record"
                            className={`${this.iconClass} ${classOutLineFocus}`}
                            onClick={(e) => this.controlOnclic(e)}
                            ref={`ahref_${control.type}`}
                            data-sn-left={nav.left}
                            data-sn-right={nav.right}
                            data-sn-up={nav.up}
                            data-sn-down={nav.down}
                            onMouseEnter={(e) => this.handleMouseEnter(e)}
                        >
                            <span className="ihelper"></span>
                            <img
                                src={Asset.get('playing_playerControls_toolbar_button_changeLanguage', Asset.get('player_controls_lang_icon'))}
                                alt="player_controls_lang_icon"
                            />
                        </a>
                    </div>
                    <div className="video-player-control-button-title">
                        {control.title}
                    </div>
                </div>
                    ;
                break;
            case CONTROL_FORWARD:
                button = <div className="video-player-control-cell">
                    <div className="video-player-control-button-icon">
                        <a
                            id={id}
                            href="javascript:void(0)"
                            key="forward"
                            className={`${this.iconClass} video-player-control-button-forward ${classOutLineFocus}`}
                            onClick={(e) => this.controlOnclic(e)}
                            ref={`ahref_${control.type}`}
                            data-sn-left={nav.left}
                            data-sn-right={nav.right}
                            data-sn-up={nav.up}
                            data-sn-down={nav.down}
                            onMouseEnter={(e) => this.handleMouseEnter(e)}
                        >
                            <span className="ihelper"></span>
                            <img
                                src={Asset.get('playing_playerControls_toolbar_button_forward', Asset.get('player_controls_forward_icon'))}
                            />
                        </a>
                    </div>
                    <div
                        className="video-player-control-button-title"
                        ref={`video_control_title_${control.type}`}
                        data={`video_control_title_${control.type}`}
                    >
                        {control.title}
                    </div>
                </div>
                break;
                case CONTROL_TS_FORWARD:
                    button = <div className="video-player-control-cell">
                        <div className="video-player-control-button-icon">
                            <a
                                id={id}
                                href="javascript:void(0)"
                                key="forward"
                                className={`${this.iconClass} video-player-control-button-forward ${classOutLineFocus}`}
                                onClick={(e) => this.controlOnclic(e)}
                                ref={`ahref_${control.type}`}
                                data-sn-left={nav.left}
                                data-sn-right={nav.right}
                                data-sn-up={nav.up}
                                data-sn-down={nav.down}
                                onMouseEnter={(e) => this.handleMouseEnter(e)}
                            >
                                <span className="ihelper"></span>
                                <img
                                    src={Asset.get('playing_playerControls_toolbar_button_seekTsForward', Asset.get('player_controls_forward_icon'))}
                                />
                            </a>
                        </div>
                        <div
                            className="video-player-control-button-title"
                            ref={`video_control_title_${control.type}`}
                            data={`video_control_title_${control.type}`}
                        >
                            {control.title}
                        </div>
                    </div>
                    break;
            case CONTROL_SPEED_FORWARD:
                    button = <div className="video-player-control-cell">
                        <div className="video-player-control-button-icon">
                            <a
                                id={id}
                                href="javascript:void(0)"
                                key="forward"
                                className={`${this.iconClass} video-player-control-button-forward ${classOutLineFocus}`}
                                onClick={(e) => this.controlOnclic(e)}
                                ref={`ahref_${control.type}`}
                                data-sn-left={nav.left}
                                data-sn-right={nav.right}
                                data-sn-up={nav.up}
                                data-sn-down={nav.down}
                                onMouseEnter={(e) => this.handleMouseEnter(e)}
                            >
                                <span className="ihelper"></span>
                                <img
                                    src={Asset.get('playing_playerControls_toolbar_button_forward', Asset.get('player_controls_forward_icon'))}
                                />
                            </a>
                        </div>
                        <div
                            className="video-player-control-button-title"
                            ref={`video_control_title_${control.type}`}
                            data={`video_control_title_${control.type}`}
                        >
                            {control.title}
                        </div>
                    </div>
                    break;
            case CONTROL_EXIT:
                button = <div className="video-player-control-cell">
                    <div className="video-player-control-button-icon">
                        <a
                            id={id}
                            href="javascript:void(0)"
                            key="exit"
                            className={`${this.iconClass} ${classOutLineFocus}`}
                            onClick={(e) => this.controlOnclic(e)}
                            ref={`ahref_${control.type}`}
                            data-sn-left={nav.left}
                            data-sn-right={nav.right}
                            data-sn-up={nav.up}
                            data-sn-down={nav.down}
                            onMouseEnter={(e) => this.handleMouseEnter(e)}
                        >
                            <span className="ihelper"></span>
                            <img
                                src={Asset.get('player_controls_back_icon')}
                            />
                        </a>
                    </div>
                    <div className="video-player-control-button-title">
                        {control.title}
                    </div>
                </div>
                break;
            case CONTROL_SERIE:
                button = <div className="video-player-control-cell">
                    <div className="video-player-control-button-icon">
                        <a
                            id={id}
                            href="javascript:void(0)"
                            key="record"
                            className={`${this.iconClass} ${classOutLineFocus}`}
                            onClick={(e) => this.controlOnclic(e)}
                            ref={`ahref_${control.type}`}
                            data-sn-left={nav.left}
                            data-sn-right={nav.right}
                            data-sn-up={nav.up}
                            data-sn-down={nav.down}
                            onMouseEnter={(e) => this.handleMouseEnter(e)}
                        >
                            <span className="ihelper"></span>
                            <img
                                src={Asset.get('playing_playerControls_toolbar_button_seasons', Asset.get('player_controls_seasons_icon'))}
                            />
                        </a>
                    </div>
                    <div className="video-player-control-button-title">
                        {control.title}
                    </div>
                </div>
                break;
            case CONTROL_FAVORITE:
                button = <div className="video-player-control-cell">
                    <div className="video-player-control-button-icon">
                        <a
                            id={id}
                            href="javascript:void(0)"
                            key="follow"
                            className={`${this.iconClass} ${classOutLineFocus}`}
                            onClick={(e) => this.controlOnclic(e)}
                            ref={`ahref_${control.type}`}
                            data-sn-left={nav.left}
                            data-sn-right={nav.right}
                            data-sn-up={nav.up}
                            data-sn-down={nav.down}
                            onMouseEnter={(e) => this.handleMouseEnter(e)}
                        >
                            <span className="ihelper"></span>
                            {/* SE DEBE BORRAR SEGUNDO ASSETS, ES SOLO PARA PRUEBAS */}
                            <img
                                src={Asset.get('playing_playerControls_toolbar_button_addList')}
                            />
                        </a>
                    </div>
                    <div className="video-player-control-button-title" id='favorite'>
                        {control.title}
                    </div>
                </div>
                break;
            case CONTROL_UNFAVORITE:
                button = <div className="video-player-control-cell">
                    <div className="video-player-control-button-icon">
                        <a
                            id={id}
                            href="javascript:void(0)"
                            key="follow"
                            className={`${this.iconClass} ${classOutLineFocus}`}
                            onClick={(e) => this.controlOnclic(e)}
                            ref={`ahref_${control.type}`}
                            data-sn-left={nav.left}
                            data-sn-right={nav.right}
                            data-sn-up={nav.up}
                            data-sn-down={nav.down}
                            onMouseEnter={(e) => this.handleMouseEnter(e)}
                        >
                            <span className="ihelper"></span>
                            {/* SE DEBE BORRAR SEGUNDO ASSETS, ES SOLO PARA PRUEBAS */}
                            <img
                                src={Asset.get('playing_playerControls_toolbar_button_deleteList')}
                            />
                        </a>
                    </div>
                    <div className="video-player-control-button-title" id='favorite'>
                        {control.title}
                    </div>
                </div>
                break;
            default:
                button = 'default';
        };

        return button;
    }

    render() {
        logger.debug('[NPC] VideoPlayerControls render');
        return (
            <Column lg={1} className={cls(`video-player-control-container`)}>
                {this.resolveIcon(this.props.control, this.props.id, this.props.nav)}
            </Column>
        );
    }
}

export default VideoPlayerControl;



// WEBPACK FOOTER //
// ./src/playerDomain/components/common/VideoPlayerControl.js